import MarketingCampaign from '@/Component/Admin/MarketingCampaign'

const MarketingCampaignsPage = () => {
  return (
    <MarketingCampaign />
  )
}

export default MarketingCampaignsPage
